import { HeadingPages } from '../../../components/HeadingPages'
import Header from '../../../components/Header'
import {
  Button,
  Flex,
  Select,
  Table,
  TableContainer,
  Tbody,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { Td, Th } from './styles'
import InputFloating from '../../../components/InputFloating'
import { useForm } from 'react-hook-form'
import Axios from 'axios'
import { useEffect, useState, useMemo, useCallback } from 'react'
import { baseURL } from '../../../services/api'
import { Row } from './Row'
import { Pagination } from './Pagination'

export function ControleTrocas() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = useForm()
  const [dataItems, setDataItems] = useState([])
  const [page, setPage] = useState(1)
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  })

  const [loadingPage, setLoadingPage] = useState(false)

  const pendent = watch('pendente')

  const handlePrevPage = () => {
    setPage((oldValue) => oldValue - 1)
  }

  const handleNextPage = () => {
    setPage((oldValue) => oldValue + 1)
  }

  const handlePageClick = (newPage) => {
    setPage(newPage)
  }

  const handleSearch = useCallback(
    async (data) => {
      setLoadingPage(true)
      const response = await baseURL.get(
        `/controle-crm/controle-troca?page=${page}&pendente=${data.pendente}&data_inicio=${data.data_inicio}&data_final=${data.data_final}`
      )


      setDataItems(response.data.data)

      setPagination({
        current_page: response.data.current_page,
        last_page: response.data.last_page,
      })

      setLoadingPage(false)
    },
    [page]
  )

  const renderedList = useMemo(() => {
    return dataItems.map((item) => <Row key={item.id} item={item} />)
  }, [dataItems])

  useEffect(() => {
    handleSearch({ pendente: pendent, data_inicio: '', data_final: '' })
  }, [handleSearch])

  return (
    <>
      <HeadingPages name="Controle de Trocas" />
      <Flex
        marginBlock="1.5rem"
        maxW="1050px"
        marginInline="auto"
        justifyContent="space-between"
        gap={2}
        as="form"
        onSubmit={handleSubmit(handleSearch)}
      >
        <InputFloating label="De: " type="date" {...register('data_inicio')} />
        <InputFloating label="Até:" type="date" {...register('data_final')} />

        <Select
          placeholder="Pendente"
          {...register('pendente')}
          defaultValue={''}
        >
          <option value="S">Sim</option>
          <option value="">Não</option>
        </Select>
        <Button
          variant="ghost"
          colorScheme="blue"
          type="submit"
          isLoading={isSubmitting}
        >
          Buscar
        </Button>
      </Flex>
      <TableContainer
        maxW="100%"
        overflowX="auto"
        height="calc(100vh - 20rem)"
        overflowY="auto"
      >
        <Table size="sm" variant="striped">
          <Thead position="sticky" top="0" bg="#378BBF" zIndex="1">
            <Tr>
              <Th>Pedido</Th>
              <Th>Cod. Innovation</Th>
              <Th>Fornecedor</Th>
              <Th>Quantidade</Th>
              <Th>Quantidade de trocas</Th>
              <Th>Nº Total de trocas</Th>
              <Th>Percentual de troca</Th>
              <Th>Data inicio troca</Th>
              <Th>Data término troca</Th>
              <Th>Data de entrega</Th>
              <Th>Dias uteis de produção</Th>
            </Tr>
          </Thead>

          {loadingPage && (
            <Tbody>
              <Tr>
                <Td colSpan="15">Carregando página {page}...</Td>
              </Tr>
            </Tbody>
          )}

          {!loadingPage && <Tbody>{renderedList}</Tbody>}
        </Table>
      </TableContainer>
      <Flex
        maxW="1050px"
        width="100%"
        marginInline="auto"
        justifyContent="center"
        paddingBlock="1rem"
      >
        <Pagination
          handlePrevPage={handlePrevPage}
          handleNextPage={handleNextPage}
          handlePageClick={handlePageClick}
          pagination={pagination}
        />
      </Flex>
    </>
  )
}
